import Image from 'next/image'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { formatPhoneMasked } from '@/shared/lib/validation/phone'
import { Button } from '@/shared/ui'

import { formatMinutesSeconds } from '../../lib/format-minutes-seconds'
import { useAuthByPhoneContext } from '../auth-by-phone/auth-by-phone.context'
import { ResendButton } from '../resend-button/resend-button'
import { RuleNotation } from '../rule-notation/rule-notation'

import cl from './style.module.scss'

export const CodeByUserCall = () => {
	const { phone, smsCodeError, isLoading, isNewUser, resendCooldown, isCooldown, goToPhone, requestSmsCode } =
		useAuthByPhoneContext()
	const { isMobile } = useMediaQueries()

	if (!phone) return null

	return (
		<div className={cl.root}>
			<div className={cl.wrapper}>
				<p className={cl.title}>Позвоните нам</p>
				<div className={cl.section}>
					<p className={cl.subtitle}>Позвоните с номера</p>
					<p className={cl.phone_wrap}>
						<span>{formatPhoneMasked(phone)}</span>
						<Button theme="link" onClick={goToPhone}>
							Изменить
						</Button>
					</p>
				</div>

				<div className={cl.section}>
					<p className={cl.phone_wrap}>
						<span className={cl.subtitle}>на номер</span>
						<a href="tel:+7 812 240-04-04">+7 812 240-04-04</a>
					</p>
				</div>

				{isMobile && (
					<Button as="a" href="tel:+7 812 240-04-04" className={cl.callButton}>
						Позвонить
					</Button>
				)}

				<div className={cl.bottom}>
					{smsCodeError && <p className={cl.error}>{smsCodeError}</p>}
					{isNewUser && <RuleNotation />}
					<ResendButton
						resendLabel="Запросить смс-код"
						onResend={requestSmsCode}
						isLoading={isLoading}
						isDisabled={isCooldown}>
						Запросить SMS с кодом через {formatMinutesSeconds(resendCooldown)}
					</ResendButton>
				</div>
			</div>

			<div>
				{!isMobile && (
					<Image
						src={`/auth-by-user-call/callByUserPhone-new.png`}
						alt={''}
						width={278}
						height={291}
						className={cl.img}
						style={{ objectFit: 'contain' }}
					/>
				)}

				{isMobile && <Image src={`/auth-by-user-call/callByUserPhoneMobile.png`} alt={''} width={375} height={290} />}

				<div className={cl.linear}></div>
			</div>
		</div>
	)
}
